// src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Facebook, 
  Twitter, 
  Instagram, 
  Linkedin,
  Mail,
  Phone,
  Calendar,Network,HelpCircle,Shield,FileText,MapPin,Users,Briefcase,GraduationCap
} from 'lucide-react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer className="bg-white border-t">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
       {/* About Section */}
<div className="space-y-4">
  <Link to="/" className="flex-shrink-0 relative group inline-flex">
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <img
        src="https://res.cloudinary.com/db4e3hqfv/image/upload/v1733974352/Saarthi_Logo_1_agutln.png"
        alt="Saarthi"
        className="h-20 w-auto"
      />
      <div className="absolute inset-0 rounded-lg bg-blue-400/0 group-hover:bg-blue-400/10 transition-colors -m-2" />
    </motion.div>
  </Link>
  <p className="text-gray-600 text-sm leading-relaxed pl-1">
    Empowering alumni connections and fostering lifelong relationships through our comprehensive networking platform.
  </p>
</div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Quick Links
            </h3>
            <ul className="space-y-3">
              {[
                { label: 'Alumni Directory', path: '/directory', icon: Users },
                { label: 'Job Portal', path: '/jobs', icon: Briefcase },
                { label: 'Events', path: '/events', icon: Calendar },
                { label: 'Campaigns', path: '/campaigns', icon: Network }
              ].map((item) => (
                <li key={item.path}>
                  <Link 
                    to={item.path}
                    className="text-gray-500 hover:text-gray-900 flex items-center group"
                  >
                    <item.icon className="h-4 w-4 mr-2 text-gray-400 group-hover:text-blue-500" />
                    <span className="text-sm">{item.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Resources
            </h3>
            <ul className="space-y-3">
              {[
                { label: 'Help Center', icon: HelpCircle },
                { label: 'Privacy Policy', icon: Shield },
                { label: 'Terms of Service', icon: FileText },
                { label: 'Contact Support', icon: Mail }
              ].map((item) => (
                <li key={item.label}>
                  <a 
                    href="#"
                    className="text-gray-500 hover:text-gray-900 flex items-center group"
                  >
                    <item.icon className="h-4 w-4 mr-2 text-gray-400 group-hover:text-blue-500" />
                    <span className="text-sm">{item.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              Stay Connected
            </h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-gray-400" />
                <span className="text-sm text-gray-600">support@saarthi.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin className="h-5 w-5 text-gray-400" />
                <span className="text-sm text-gray-600">Gandhinagar, India</span>
              </div>
              <div className="flex space-x-4">
                {[
                  { icon: Facebook, color: 'hover:text-blue-600' },
                  { icon: Twitter, color: 'hover:text-blue-400' },
                  { icon: Instagram, color: 'hover:text-pink-600' },
                  { icon: Linkedin, color: 'hover:text-blue-700' }
                ].map((social, index) => (
                  <a
                    key={index}
                    href="#"
                    className={`text-gray-400 transform hover:scale-110 transition-all ${social.color}`}
                  >
                    <social.icon className="h-5 w-5" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-500">
              © {new Date().getFullYear()} Saarthi. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-sm text-gray-500 hover:text-gray-900">
                Privacy
              </a>
              <a href="#" className="text-sm text-gray-500 hover:text-gray-900">
                Terms
              </a>
              <a href="#" className="text-sm text-gray-500 hover:text-gray-900">
                Cookies
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;